import { createService } from '@/helpers/hasura'

import gql from 'graphql-tag'

import { ItemFragment, ItemGroupFragment } from '@/helpers/api/fragments'

const output = `
    ...Item
    item_group { ...ItemGroup }
`

const fragments = gql`
  ${ItemFragment}
  ${ItemGroupFragment}
`

const allowedFields = []

export default config => {
  const service = createService({
    ...config,
    table: 'item',
    defaultPageSize: 25,
    defaultOrderBy: [{ rating: 'asc', short_description: 'asc' }],
    defaultSearchBy: ['code', 'short_description'],
    defaultFilters: [],
    uniqueFields: ['code'],
    defaultOutput: output,
    defaultFragments: fragments,
    allowedFields
  })

  return {
    ...service,
    fetchCustomForms: payload => {
      let { filters = [] } = payload

      filters = [...filters, { webshop_custom_form: { _is_null: false } }]

      return service.fetchPage({ ...payload, filters })
    }
  }
}
